// @flow
import styled from 'styled-components';

export const Inner = styled.div`
  margin: 30px auto;

  svg {
    margin-left: 4px;
    vertical-align: middle;
  }
`;

export const LoadButton = styled.button`
  display: inline-block;
  width: 100%;
  border: 0 solid ${({ theme }) => theme.colors.ui};
  border-radius: 4px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.bodyFontFamily};
  font-size: 15px;
  font-weight: 700;

  color: ${({ theme, light }) => (light ? theme.fontLightColor : theme.colors.primary)};
  text-align: center;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme, disabled }) => (disabled ? theme.fontLightColor : theme.colors.primary)};
  }

  &[disabled] {
    border: none;
    border-color: ${({ theme }) => theme.colors.uiD};
    color: ${({ theme }) => theme.colors.uiD};
  }
`;
